import { all, fork } from 'redux-saga/effects';

import listenFiltersChange from './listenFiltersChange';
import listenLoad from './listenLoad';
import listenLoadPage from './listenLoadMore';

export default function* hostAllBookingsSaga() {
  yield all([fork(listenLoad), fork(listenLoadPage), fork(listenFiltersChange)]);
}
